export default {
  en: {
    'components.create-message-form.subject.validation.required': 'Subject required',
    'components.create-message-form.subject.label': 'Subject',
    'components.create-message-form.subject.placeholder': 'Message subject',

    'components.create-message-form.body.validation.required': 'Message required',
    'components.create-message-form.body.label': 'Message',
    'components.create-message-form.body.placeholder': 'Type a message',

    'components.create-message-form.participants.validation.required': 'Recipient required',
    'components.create-message-form.participants.label': 'To:',

    'components.create-message-form.send': 'Send',
    'components.create-message-form.cancel': 'Cancel',
  },
};
